<template>
  <ui-container>
    <ui-row align-h="center">
      <ui-spinner center v-if="showLoader"></ui-spinner>
      <ui-col lg="10" v-if="article">
        <ui-card>
          <p @click="$router.go(-1)" class="pointer">
            <span class="color-light">
              <ui-icon name="icon-left"></ui-icon>{{ article.bookTitle || article.eventName }}
            </span>
          </p>
          <ui-hr></ui-hr>
          <ui-avatar :url="article.userInfo.avatar" :username="article.userInfo.username ? article.userInfo.username : $t('anonymous')">{{ $d(new Date(article.created), "long") }}</ui-avatar>
          <div class="article-content" id="content">
            <div v-html="html"></div>
          </div>
          <div class="article-meta">
            <!-- <p v-if="article.geo && article.geo.address">{{article.geo.address}}</p>
        <p v-if="article.geo && article.geo.weather">
          <i :class="'editor-icon-' + article.geo.weather.weatherCode"></i>{{article.geo.weather.temp}}℃
        </p> -->
            <div class="bar"></div>
          </div>
          <article-action :article="article"></article-action>
        </ui-card>
      </ui-col>
      <ui-col lg="10" v-if="article && authInfo">
        <comment :article="article" class="mt-5"></comment>
      </ui-col>
    </ui-row>
  </ui-container>
</template>
<script>
import api from "../api/index";
import ArticleAction from "../components/article/ArticleAction.vue";
import Comment from "../components/comment/comment.vue";
import { mapGetters } from "vuex";
import renderPlayer from "../utils/renderPlayer.js";
import "aplayer/dist/APlayer.min.css";

// import APlayer from "aplayer";
export default {
  data() {
    return {
      article: null,
      showLoader: true,
      html: ""
    };
  },
  computed: {
    ...mapGetters(["authInfo"])
  },
  components: {
    ArticleAction,
    Comment
  },
  mounted() {
    let id = this.$route.params.id;
    api
      .getContentById(id)
      .then(response => {
        this.article = response.data.content;
        this.html = this.article.content;
        this.$nextTick(() => {
          renderPlayer(
            this.$el.querySelectorAll(".editor-mp3-holder"),
            this.article.fileHash
          );
        });
        this.showLoader = false;
      })
      .catch(err => {
        this.showLoader = false;
        this.$UiToast({
          message: this.$t("nothingToView"),
          type: "warning"
        });
        setTimeout(() => {
          this.$router.push("/index");
        }, 2000);
      });
  },
  methods: {}
};

</script>
